<div class="form-group">
  @if (inputParams) {
    <div class="parameters-box">
      @for (inputParam of inputParams; track inputParam) {
        <div
          class="input-param"
          [ngClass]="{'has-error':!enteredInputGroup.controls[inputParam].valid && enteredInputGroup.controls[inputParam].touched}">
          <div class="param-name" id="param-{{inputParam}}">
            {{inputParam === 'CCID' ? 'Account ID (CCID)' : inputParam}}
          </div>
          <input type="text" class="form-control" id="{{inputParam}}-input"
            [formControl]="enteredInputGroup.controls[inputParam]"
            [attr.disabled]="isInputDisabled(inputParam) ? '' : null"
            (keyup)="onKeyUp($event)">
          <app-error-display [control]="enteredInputGroup.controls[inputParam]"></app-error-display>
        </div>
      }
    </div>
  }
</div>
